export const GOOGLE_PAY_COUNTRY_CONFIG = {
    br: {
        allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
        allowedCardNetworks: ['VISA', 'ELECTRON', 'MASTERCARD', 'MAESTRO', 'ELO', 'ELO_DEBIT'],
    },
    ca: {
        allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
        allowedCardNetworks: ['AMEX', 'DISCOVER', 'MASTERCARD', 'VISA'],
    },
}

export const GOOGLE_PAY_COUNTRY_META = {
    br: { countryCode: 'BR', currencyCode: 'BRL', gateway: 'pagbank' },
    ca: { countryCode: 'CA', currencyCode: 'CAD', gateway: 'moneris' },
}

export const getGooglePayCountryKey = () => {
    const country = (window.COUNTRY || '').toLowerCase()
    if (country === 'ca') return 'ca'
    if (country.startsWith('br')) return 'br' // e.g. br-neo
    return null
}

export const getGooglePayCountryMeta = () => {
    const key = getGooglePayCountryKey()
    return key ? GOOGLE_PAY_COUNTRY_META[key] : null
}
